var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniLeisure03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.621094,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#4A5294"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_500_12905",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.621094,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_500_12905)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.902,
    y: 109.832,
    width: 6.15246,
    height: 118.817,
    transform: "rotate(32.1381 190.902 109.832)",
    fill: "#FFECE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.403 30.7587C211.341 26.0821 217.514 24.6727 222.19 27.6106L256.609 49.2334C261.286 52.1714 262.695 58.3441 259.757 63.0207L233.571 104.704C230.124 110.19 224.233 113.667 217.763 114.032L190.948 115.547L180.673 90.7315C178.195 84.7448 178.77 77.9282 182.217 72.4415L208.403 30.7587Z",
    fill: "#DD7F4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.431 69.6658C215.524 69.5171 215.655 69.3956 215.811 69.3136L221.309 66.4077C221.65 66.2278 222.057 66.4837 222.043 66.8683L221.811 73.0835C221.805 73.259 221.752 73.4296 221.659 73.5783L189.509 124.755C189.216 125.222 188.598 125.363 188.131 125.069L183.596 122.221C183.129 121.927 182.988 121.31 183.281 120.842L215.431 69.6658Z",
    fill: "#342015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.583 216.955L137.885 206.921C138.179 206.454 138.038 205.836 137.571 205.543L133.036 202.694C132.569 202.4 131.951 202.541 131.658 203.009L125.355 213.042L131.583 216.955Z",
    fill: "#342015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.953 219.15L138.882 216.078C139.176 215.61 139.035 214.993 138.567 214.699L124.355 205.77C123.887 205.477 123.27 205.618 122.976 206.085L121.047 209.158C120.753 209.626 120.894 210.243 121.362 210.537L135.574 219.465C136.042 219.759 136.659 219.618 136.953 219.15Z",
    fill: "#342015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.356 184.75L150.529 184.753L157.023 175.799L159.17 172.473C155.538 175.224 149.338 180.383 145.356 184.75Z",
    fill: "#FFEFE7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.332,
    y: 124.361,
    width: 5.07072,
    height: 97.9261,
    transform: "rotate(48.2092 213.332 124.361)",
    fill: "#FFECE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.59 64.2831C245.04 60.3058 251.961 61.0866 255.412 65.9555L270.286 86.9359C273.008 90.775 272.685 95.9923 269.51 99.4659L248.085 122.907C242.85 128.634 234.775 130.817 227.368 128.507L212.62 123.908L208.741 106.467C207.17 99.401 209.539 92.0373 214.936 87.2133L240.59 64.2831Z",
    fill: "#342015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.919 66.8985C248.037 63.218 254.359 63.5725 258.039 67.6902L278.021 90.0459C281.701 94.1636 281.347 100.485 277.229 104.166L249.645 128.821C244.814 133.139 238.191 134.849 231.873 133.409L212.061 128.894L209.789 108.701C209.064 102.262 211.504 95.8715 216.335 91.5534L243.919 66.8985Z",
    fill: "#DD7F4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.881 98.1741C242.012 98.057 242.172 97.9766 242.344 97.9407L247.166 96.9346C247.543 96.856 247.864 97.2147 247.744 97.5803L246.205 102.26C246.15 102.427 246.052 102.577 245.921 102.694L208.95 135.74C208.538 136.108 207.906 136.073 207.538 135.661L204.831 132.632C204.463 132.221 204.498 131.588 204.91 131.22L241.881 98.1741Z",
    fill: "#342015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.908 195.667L149.058 189.276C149.47 188.908 149.505 188.276 149.137 187.864L146.43 184.835C146.062 184.424 145.43 184.388 145.018 184.756L137.869 191.147L141.908 195.667Z",
    fill: "#342015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 198.509L147.759 196.75C148.171 196.382 148.206 195.75 147.838 195.338L138.854 185.287C138.486 184.875 137.854 184.84 137.442 185.208L135.475 186.967C135.063 187.335 135.028 187.967 135.396 188.379L144.38 198.43C144.749 198.842 145.381 198.878 145.793 198.509Z",
    fill: "#342015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.289 242.711V222.914H190.055C194.553 222.914 197.137 225.689 197.137 229.586C197.137 233.537 194.512 236.258 189.945 236.258H186.391V242.711H182.289ZM186.391 232.949H189.289C191.723 232.949 192.912 231.582 192.898 229.586C192.912 227.617 191.723 226.291 189.289 226.277H186.391V232.949ZM201.102 242.957C199.816 242.957 198.777 241.932 198.805 240.66C198.777 239.402 199.816 238.377 201.102 238.391C202.318 238.377 203.371 239.402 203.371 240.66C203.371 241.932 202.318 242.957 201.102 242.957ZM206.707 242.711V222.914H214.473C218.971 222.914 221.555 225.689 221.555 229.586C221.555 233.537 218.93 236.258 214.363 236.258H210.809V242.711H206.707ZM210.809 232.949H213.707C216.141 232.949 217.33 231.582 217.316 229.586C217.33 227.617 216.141 226.291 213.707 226.277H210.809V232.949ZM228.117 222.914V242.711H224.07V222.914H228.117ZM237.988 243.012C233.436 242.998 230.646 240.059 230.66 235.355C230.646 230.775 233.477 227.672 237.824 227.672C241.721 227.672 244.797 230.133 244.797 235.191V236.34H234.652C234.652 238.582 235.979 239.963 238.07 239.977C239.451 239.963 240.436 239.361 240.832 238.473H244.688C244.113 241.221 241.652 242.998 237.988 243.012ZM234.652 233.797H240.969C240.955 231.992 239.711 230.693 237.906 230.707C236.047 230.693 234.734 232.088 234.652 233.797Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLeisure03);
export default __webpack_public_path__ + "static/media/mini_leisure_03.c2c763b5613c30fbc3d804cd22c91a77.svg";
export { ForwardRef as ReactComponent };